import { mapGetters } from 'vuex';
import _ from 'lodash'

export default {
    computed: {
        ...mapGetters('classifications', [
            'classifications',
        ]),
    },
    methods: {
        getClassificationNameById(id) {
            let classification = this.classifications.find(classification => classification.TypeID == id);
    
            return _.get(classification, 'TypeName');
        },
    },
}